import { hexA } from '../../lib/lens'

const W = 320
const H = 90
const P = 8

interface SparklineProps {
  values: (number | null)[]
  accent: string
}

export function Sparkline({ values, accent }: SparklineProps) {
  // Null buckets are gaps — drop them from the line; scale to the real values present.
  const nums = values.filter((v): v is number => v !== null)
  const min = nums.length ? Math.min(...nums) : 0
  const max = nums.length ? Math.max(...nums) : 1
  const span = Math.max(1, values.length - 1)
  const x = (i: number) => P + (i * (W - 2 * P)) / span
  const y = (v: number) => H - P - ((v - min) / (max - min || 1)) * (H - 2 * P)
  const pts = values
    .map((v, i) => (v === null ? null : `${x(i).toFixed(1)},${y(v).toFixed(1)}`))
    .filter((p): p is string => p !== null)
    .join(' ')
  return (
    <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" className="block h-24 w-full">
      <polygon points={`${P},${H - P} ${pts} ${W - P},${H - P}`} fill={hexA(accent, 0.12)} />
      <polyline points={pts} fill="none" stroke={accent} strokeWidth="2" />
    </svg>
  )
}
